<template>

    <div class="content-wrap page-biere">

        <header class="hero--sm">
            <h1 class="hero-heading">
                Zissel<br>
                <small>zischt fränkisch!</small>
            </h1>
        </header>

        <section class="section--interlude">

            <div class="container">

                <div class="row">

                    <div class="col sm-8">

                        <h2>Unsere Zissel-Biere</h2>

                        <p>
                            brauen wir nach altem Rezept
                            mit heimischen Rohstoffen aus bester Qualität.
                        </p>
                        <p>
                            Ob frisch gezapft aus dem Fass oder aus unseren<br>
                            unverwechselbaren Bügelflaschen – <b>ein Zissel ist immer ein Genuss.</b>
                        </p>
                    </div>

                </div>
            </div>


        </section>



        <featured-products></featured-products>



        <section class="section--dark">

            <ul class="product-list">

                <li class="product-list__item">

                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"><g stroke="#FFF" stroke-width="2" fill="none" fill-rule="evenodd"><path d="M17 33c-1.167 3.667-.292 7.792 2 10 4.997-1.376 6.895-4.023 9-8"/><path d="M21 42c-.625 4.458 2.031 6.937 4 9 2.048-.564 2.906-1.875 4-4M32 36.082c2.542-.499 7-3.249 7-7.082 4.3 4.166 7.417 4.041 11 4.082C50 22.125 41.941 15 32 15s-18 7.125-18 18.082c3.583-.041 6.7.084 11-4.082 0 3.833 4.458 6.583 7 7.082z"/><path d="M47 33c1.167 3.667.292 7.792-2 10-4.997-1.376-6.895-4.023-9-8"/><path d="M39 40c0 4.331-3.1 7.875-7 9-3.9-1.125-7-4.669-7-9"/><path d="M43 42c.625 4.458-2.031 6.937-4 9-2.048-.564-2.906-1.875-4-4"/><path d="M37 49.9648c-.937 3.16-2.781 5.254-5 6.035-2.219-.781-4.063-2.875-5-6.035M32 9v6"/></g></svg>

                    <h2>Zissel Hell</h2>
                    <p>Spritzig herb – unser Helles wird mit Hopfen aus<br>
                        der Hallertau gebraut. Er verleiht unserem Bier die<br>
                        unvergleichliche Würze sowie seinen spritzig herben Charakter. </p>
                </li>

                <li class="product-list__item">

                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" class="svg replaced-svg"><title>BottleCrate</title><g stroke="#FFF" stroke-width="2" fill="none" fill-rule="evenodd"><path d="M9 44V34h46v10H9zm46 0v10H9V44h46zM11 44h42M12 39h2M50 39h2M12 49h2M50 49h2M27 34v-2c0-3.594-4-5.126-4-7 0-3.417-1-9.756-1-10 0-.617 1-.833 1-2 0-.466-1-.792-1-1v-1c0-.64-1-1-3-1s-3 .36-3 1v1c-.438.208-1 .534-1 1 0 1.167 1 1.383 1 2 0 .244-1 6.583-1 10 0 1.874-4 3.406-4 7v2M40 34v-2c0-3.594-4-5.126-4-7 0-3.417-1-9.756-1-10 0-.617 1-.833 1-2 0-.466-1-.792-1-1v-1c0-.64-1-1-3-1s-3 .36-3 1v1c-.438.208-1 .534-1 1 0 1.167 1 1.383 1 2 0 .244-1 6.583-1 10 0 .611-.426 1.292-1 2.058M53 34v-2c0-3.594-4-5.126-4-7 0-3.417-1-9.756-1-10 0-.617 1-.833 1-2 0-.466-1-.792-1-1v-1c0-.64-1-1-3-1s-3 .36-3 1v1c-.438.208-1 .534-1 1 0 1.167 1 1.383 1 2 0 .244-1 6.583-1 10 0 .611-.426 1.292-.999 2.058"/></g></svg>

                    <h2>Zissel Dunkel</h2>
                    <p>Unser Dunkles ist ein untergäriges Vollbier, typisch<br>
                        fränkisch und würzig im Geschmack.</p>
                </li>

                <li class="product-list__item">

                    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 57.234 57.234"><path fill="#FFF" d="M57.23 49.927c-.001-.037.001-.075-.001-.112-.018-.316-.067-.627-.138-.932-.011-.049-.02-.099-.033-.148-.081-.309-.19-.609-.322-.898-.011-.023-.015-.048-.025-.071-.012-.024-.029-.044-.041-.069-.137-.28-.297-.549-.48-.803-.036-.05-.076-.097-.114-.146-.181-.234-.379-.457-.598-.66-.043-.04-.09-.077-.134-.115-.229-.2-.473-.385-.737-.547-.034-.021-.071-.038-.106-.058-.273-.159-.562-.298-.869-.41-.014-.005-.026-.014-.04-.019-.008-.003-.016-.004-.024-.006l-14.225-5.094c3.458-3.585 5.653-8.933 5.653-15.22 0-11.562-3-16-3-16 0 9.5-8 16-8 16 0-7.5-3-14-3-14 0 5.875-4 9-4 9-5.344-5.344 0-18 0-18-7.61 1.004-14.425 6.25-14.425 15 0 6.188 1.728 10.304 4.425 13 0 0-2.393-1.388-4.78-2.304.632 5.003 2.721 9.4 5.705 12.513L3.666 44.931c-.008.003-.016.004-.024.006-.014.005-.026.014-.04.019-.307.112-.595.251-.869.41-.035.02-.071.038-.106.058-.264.162-.508.347-.737.547-.045.039-.091.075-.134.115-.219.204-.416.426-.598.66-.038.049-.077.096-.114.146-.183.254-.343.523-.48.803-.012.024-.029.044-.041.069-.011.023-.015.048-.025.071-.132.289-.241.59-.322.898-.013.049-.022.098-.033.148-.071.305-.12.616-.138.932-.002.037 0 .075-.001.112-.012.324.001.65.049.977.002.015.006.029.008.044.052.343.136.686.257 1.025.263.734.682 1.377 1.199 1.919 1.019 1.072 2.442 1.727 3.98 1.727h.011c.629 0 1.249-.108 1.844-.321l21.266-7.616 21.267 7.616c.594.213 1.214.321 1.843.321h.01c1.524 0 2.937-.643 3.954-1.698.529-.548.957-1.201 1.224-1.946.121-.339.205-.682.257-1.025.002-.015.006-.029.008-.044.047-.327.06-.654.049-.977zm-2.029.69c-.026.177-.077.353-.131.529-.015.05-.02.101-.038.15-.158.44-.406.828-.708 1.161-.652.716-1.583 1.158-2.592 1.159-.399-.001-.794-.07-1.175-.206-.88-.315-1.585-.955-1.984-1.8s-.446-1.795-.13-2.676c.497-1.388 1.821-2.321 3.295-2.321.392 0 .78.068 1.154.199l.026.009c1.345.482 2.21 1.708 2.306 3.049.001.018.007.036.008.053.01.172-.006.346-.022.52-.006.06 0 .117-.009.174zM19.906 31.849c0-3.616 2.111-5.828 5.944-6.227.336-.031.671.104.884.37.212.265.276.621.167.943-.414 1.235-.769 3.23-.428 4.206.625-.098 1.574-.359 1.574-1.036 0-.463.317-.865.768-.973.453-.106.916.108 1.125.521.042.084.786 1.569 1.185 3.462.854-1.046 1.783-2.535 1.783-4.056 0-.418.261-.793.653-.938.392-.147.833-.031 1.106.288.161.187 1.566 1.952 1.566 6.232 0 4.382-3.499 7.825-8.012 7.963-1.009-.022-2.005-.167-2.978-.431-2.835-.952-4.99-3.366-5.481-6.433-.055-.34.07-.685.33-.912.088-.077.187-.136.292-.177-.318-.827-.478-1.762-.478-2.802zM5.496 46.614c1.474 0 2.798.933 3.295 2.321.651 1.817-.298 3.825-2.115 4.476-.381.136-.776.205-1.175.206-1.01-.002-1.942-.443-2.594-1.161-.302-.333-.549-.72-.707-1.16-.018-.049-.022-.1-.038-.15-.054-.176-.106-.352-.131-.529-.008-.057-.003-.114-.009-.171-.016-.174-.032-.348-.022-.52.001-.018.007-.036.008-.053.097-1.341.961-2.567 2.306-3.049l.026-.009c.377-.132.764-.201 1.156-.201zm5.17 5.37c.159-.439.258-.901.301-1.371.009 0 .018.004.028.004.104 0 .211-.017.316-.052l6-2c.524-.175.807-.741.632-1.265-.175-.523-.74-.808-1.265-.632l-5.892 1.964c-.035-.124-.068-.248-.112-.371-.089-.247-.199-.482-.319-.71l2.956-.985c.524-.175.807-.741.632-1.265-.174-.524-.739-.809-1.265-.632l-3 1c-.212.071-.371.216-.49.387-.275-.25-.578-.466-.898-.655l11.057-3.96c2.294 1.735 4.857 2.773 7.529 3.075.05.006.099.013.148.019.487.05.976.083 1.469.083.502 0 .999-.035 1.494-.086.162-.017.322-.04.482-.062.337-.047.671-.106 1.003-.176.173-.036.347-.069.518-.112.442-.111.88-.238 1.312-.39.161-.057.317-.128.476-.19.305-.119.608-.245.907-.385.161-.076.32-.156.478-.237.377-.192.748-.401 1.114-.626.035-.022.071-.041.106-.063.45-.282.895-.579 1.327-.911l11.229 4.021c-.377.224-.733.482-1.047.789-.113-.237-.315-.431-.583-.52l-3-1c-.525-.176-1.09.108-1.265.632s.108 1.09.632 1.265l3 1c.06.02.12.021.18.029-.111.215-.216.434-.299.666-.056.158-.079.32-.121.48-.044-.022-.079-.057-.127-.073l-6-2c-.526-.175-1.091.109-1.265.632-.175.524.108 1.09.632 1.265l6 2c.105.035.212.052.316.052.094 0 .185-.018.274-.043.041.483.157.957.327 1.42l-17.979-6.439-17.948 6.428z"/></svg>

                    <h2>Zissel Rauch</h2>
                    <p>Das Malz zur Herstellung unseres Rauchbieres wird über<br>
                        Buchenholzfeuer geröstet und gibt den rauchigen Geschmack<br>
                        an das Bier weiter. </p>
                </li>

                <li class="product-list__item">


                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="60" viewBox="-80 0 820 800" stroke="transparent"><path fill="#FFF" stroke="#FFF" stroke-width="60px" d="M6 6v419a319 319 0 0 0 638 0V6"/><path style="transform: translateY(10px);" fill="#1b1c1e" d="M11 11v464l114-246 100 246 100-246 100 246 100-246 114 246V11"/></svg>

                    <h2>Zissel Urtrüb</h2>
                    <p>Unser „Ungespundetes“ ist ein nach fränkischer<br>
                        Tradition gebrautes Bier – naturbelassen, hefetrüb<br>
                        und unfiltriert.</p>
                </li>
            </ul>


        </section>


        <app-footer></app-footer>

    </div>


</template>

<script>
import scrollOver from '../lib/getScrollOverElement'
import setParallax from '../lib/setParallax'

import { mapGetters } from 'vuex'
import store from '../store'

import featuredProducts from './partials/featured-products.vue'
import appFooter from './partials/footer.vue'
export default {

    components: { featuredProducts, appFooter },

    mounted() {

        this.$nextTick(() => {

            setParallax({
                el: '[class^="hero"]',
                speed: 10
            })

            scrollOver({
                el: '.featured-box',
                offset: 400,
                cb() {

                    let bottles = document.querySelectorAll('.featured-item__bottle')

                    for( let i = 0; i < bottles.length; i++ ) {
                        setTimeout(() => {
                            bottles[i].classList.add('is-inview')
                        }, 200 * i);
                    }
                }
            })

        })

    }


}
</script>



// WEBPACK FOOTER //
// biere.vue?0460300c